module.exports = __webpack_public_path__ + "static/media/clinic1.f4a86fee.png";